import { parametric, pathSubscription, subscription } from 'nike-re-framejs';
import { Map } from 'immutable';
import { CashinOfferStatus, CashinTransactionStatus, PickState } from '../../../ticketus/constants';
import { filterTicketList, sortCashinOffersByStake } from './utils';

export function isCashinOfferVisible(cashinOfferStatus) {
    return [CashinOfferStatus.Running, CashinOfferStatus.Stopped, CashinOfferStatus.InProgress].includes(
        cashinOfferStatus
    );
}

export function isCashinOfferDisabled(cashinOfferStatus) {
    return cashinOfferStatus !== CashinOfferStatus.Running;
}

export function isRunningPickAvailable(picks) {
    if (!picks) return false;
    return picks.some(pick => pick.pickState === PickState.RUNNING);
}

export function isPickDisabled(pickState) {
    return pickState === PickState.UNAVAILABLE || pickState === PickState.TRANSACTION_ACTIVE;
}

export function isCashinTransactionRunning(cashinTransactionStatus) {
    return [
        CashinTransactionStatus.Started,
        CashinTransactionStatus.Activated,
        CashinTransactionStatus.AuthorizationRequired
    ].includes(cashinTransactionStatus);
}

export const activeTransactionId$ = ticketId =>
    pathSubscription(['ticketus', 'activeTransactions', ticketId, 'transactionId']);
export const ticketIdsByMatchId$$ = matchId => pathSubscription(['ticketus', 'cashin', 'sportEvents', matchId]);
export const ticketIdsByBetId$$ = betId => pathSubscription(['ticketus', 'cashin', 'bets', betId]);
export const ticketsData$ = pathSubscription(['ticketus', 'cashin', 'tickets'], Map());
export const cashinOfferByTicketId$$ = ticketId => pathSubscription(['ticketus', 'cashin', 'tickets', ticketId]);

export const activeTransaction$$ = parametric(ticketId =>
    subscription(
        (cashinOffer, transactionId) => {
            const activeTransaction = cashinOffer.getIn(['activeTransaction'], null);
            if (!cashinOffer || !transactionId || !activeTransaction) {
                return null;
            }
            if (activeTransaction.get('id') === transactionId) {
                return activeTransaction;
            } else {
                return null;
            }
        },
        cashinOfferByTicketId$$(ticketId),
        activeTransactionId$(ticketId)
    )
);

export const cashinMatchCollapsed$$ = matchId => pathSubscription(['cashin', 'sportEvents', 'collapsed', matchId]);
export const cashinBetsCollapsed$$ = betId => pathSubscription(['cashin', 'bets', 'collapsed', betId]);

export const cashinOfferDataForMatch$$ = parametric(matchId =>
    subscription(
        (ticketIds, tickets) => {
            if (ticketIds) return sortCashinOffersByStake(filterTicketList(ticketIds, tickets));

            return undefined;
        },
        ticketIdsByMatchId$$(matchId),
        ticketsData$
    )
);

export const cashinOfferDataForBets$$ = parametric(betId => {
    return subscription(
        (ticketIds, tickets) => {
            if (ticketIds) return sortCashinOffersByStake(filterTicketList(ticketIds, tickets));

            return undefined;
        },
        ticketIdsByBetId$$(betId),
        ticketsData$
    );
});

export const activeCashin$$ = parametric(matchId =>
    subscription(
        (cashinOffers, collapsedCashin) => cashinOffers?.size && !collapsedCashin,

        cashinOfferDataForMatch$$(matchId),
        cashinMatchCollapsed$$(matchId)
    )
);
